export default __webpack_public_path__ + "static/media/warranty_guidelines.ce4bdefc.webp";